Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("./angular");
exports.Angular = angular_1.Angular;
var captureconsole_1 = require("./captureconsole");
exports.CaptureConsole = captureconsole_1.CaptureConsole;
var debug_1 = require("./debug");
exports.Debug = debug_1.Debug;
var dedupe_1 = require("./dedupe");
exports.Dedupe = dedupe_1.Dedupe;
var ember_1 = require("./ember");
exports.Ember = ember_1.Ember;
var extraerrordata_1 = require("./extraerrordata");
exports.ExtraErrorData = extraerrordata_1.ExtraErrorData;
var offline_1 = require("./offline");
exports.Offline = offline_1.Offline;
var reportingobserver_1 = require("./reportingobserver");
exports.ReportingObserver = reportingobserver_1.ReportingObserver;
var rewriteframes_1 = require("./rewriteframes");
exports.RewriteFrames = rewriteframes_1.RewriteFrames;
var sessiontiming_1 = require("./sessiontiming");
exports.SessionTiming = sessiontiming_1.SessionTiming;
var transaction_1 = require("./transaction");
exports.Transaction = transaction_1.Transaction;
var vue_1 = require("./vue");
exports.Vue = vue_1.Vue;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/integrations/dist/index.js
// module id = 926
// module chunks = 1